export enum ValidationValueType {

    Boolean = "Boolean",
    Integer = "Integer",
    String = "String",
    Regex = "Regex",
    PropertyType = "PropertyType",
    File = "File"
}
